import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from '@material-ui/core/Button';
import Quagga from 'quagga';
import Scanner from './Scanner';
import DbTasks from '../db/DbTasks';
import moment from 'moment';
import {
    SaveDataBock,
    SelectAppointmentByID
} from "../actions/TaskActions";
import {
    SelectedAppSelector
} from '../selectors/SelectedAppointmentSelector';
import { fetchCoordinates } from '../helpers/utils';

const styles = {
    paperinput: {
        textAlign: 'left',
        width: '60%',
        marginLeft: '20%',
        marginRight: '20%',
        marginTop: "20px"
    },
    paperbutton: {
        width: '40%',
        marginLeft: '30%',
        marginRight: '30%',
        textTransform: 'none',
        marginTop: "10px",
        marginBottom: "10px"
    },

    paper: {
        marginTop: "20%",
        marginLeft: "15%",
        marginRight: "15%",
        marginBottom: "10px",
        paddingBottom: "40px",
        boxShadow: "1px 1px 1px 1px #AAA",
        height: "40%"
    }
}

class ScanCode extends Component {
    state = {
        scanning: true,
        results: [],
        scanText: "Stop scanning"
    }

    componentDidMount() {
        moment.locale("de");
        this.props.SelectAppointmentByID(this.props.match.params.id);
    }

    componentWillUnmount() {
        Quagga.offDetected(this._onDetected);
    }

    _onDetected = async result => {
        console.log("OnDetected :", result);
        if (result.codeResult.code.length === 15) {
            this.setState({ results: this.state.results.concat([result]) });
            this.setState({ scanning: false });
            this.insertBock(result.codeResult.code);
        } else {
            console.log("Skeniranje neuspješno : ", result.codeResult.code);
        }
    }

    insertBock = async res => {
        let specifiedBock = new DbTasks().getSpeficiedBock;
        let bock = await specifiedBock(res);
        //console.log("Bock barcode : ", res);
        if (bock.hasOwnProperty("Bock_Nr")) {
            let app = this.props.application;
            //update postojećeg boka
            bock.Kunden_Nr = app.Kunden_Nr;
            bock.Bock_Nr = res;
            bock.ekName = app.EkName;
            bock.ekOrt = app.EkOrt;
            bock.ekPLZ = app.EkPLZ;
            bock.DateLeft = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            bock.DatePickUp = null;
            bock.Latitude = app.Lat;
            bock.Longitude = app.Lng;
            bock.Status = 1;
            bock.PlanedID = null;
            bock.FirmaID = app.IdFirma;
            bock.Strasse = app.EkStrasse;
            bock.Bereit = null;
            bock.AuftragNr = app.AuftragNr;
            bock.ToUpload = 1;
            bock.UniqueID = app.UniqueID

            let bockPos = await fetchCoordinates();

            if (!bockPos) {
                bock.Latitude = app.Lat;
                bock.Longitude = app.Lng;
            } else {
                bock.Latitude = bockPos.latitude;
                if (!bockPos.Latitude) bock.Latitude = app.Lat;
                bock.Longitude = bockPos.longitude;
                if (!bockPos.Longitude) bock.Longitude = app.Lng;
            }

            this.props.SaveDataBock(bock);
            this.props.history.goBack();
        }
    }


    stopScanning = () => {
        let scanText = this.state.scanning !== false ? "Start scanning" : "Stop scanning";
        this.setState({ scanning: !this.state.scanning, scanText: scanText });
    }

    render() {
        //console.log(this.props.application);
        return (
            <div>
                <Button
                    style={styles.paperbutton}
                    variant="outlined"
                    onClick={this.stopScanning}
                >{this.state.scanText}
                </Button>
                <div>
                    {this.state.scanning ? <Scanner onDetected={this._onDetected} /> : null}
                </div>
            </div>
        );
    }
};

const mapStateToProps = state => ({
    //application: state.app,
    application: SelectedAppSelector(state),
});

export default withRouter(
    connect(
        mapStateToProps,
        { SaveDataBock, SelectAppointmentByID }
    )(ScanCode)
);